export const promotions = {
  name: '促銷活動 |||| 促銷活動',
  fields: {
    name: '名稱',
    description: '說明',
    code: '代碼',
    promotionType: '促銷類型',
    codeType: '代碼類型',
    discountType: '折扣類型',
    discountValue: '折扣金額',
    userType: '用戶類型',
    membershipLevels: '會員等級',
    validFrom: '開始時間',
    validUntil: '結束時間',
    timeOfDayStart: '每日開始時間',
    timeOfDayEnd: '每日結束時間',
    daysOfWeek: '星期',
    minChargeAmount: '最低充電金額',
    maxUsesTotal: '總使用次數上限',
    maxUsesPerUser: '每用戶使用次數上限',
    currentUses: '已使用次數',
    priority: '優先級',
    stackableWithCoupons: '可與優惠券疊加',
    stackableWithPromotions: '可與其他促銷疊加',
    isActive: '啟用',
    sites: '站點',
    chargerTypes: '充電器類型',
    type: '類型',
    discount: '折扣',
    status: '狀態',
    uses: '使用次數',
  },
  sections: {
    basicInfo: '基本資訊',
    typeAndCode: '類型與代碼',
    discount: '折扣設定',
    targeting: '目標用戶',
    validity: '有效期限',
    timeConstraints: '時間限制',
    limits: '使用限制',
    advanced: '進階設定',
    restrictions: '適用範圍',
  },
  types: {
    coupon: '優惠券',
    time_limited: '限時促銷',
  },
  codeTypes: {
    none: '無代碼',
    shared: '共用代碼',
    unique: '獨立代碼',
  },
  discountTypes: {
    percentage: '百分比',
    fixed_amount: '固定金額',
    free_credit: '免費點數',
  },
  userTypes: {
    app: 'App用戶',
    rfid: 'RFID用戶',
    all: '所有用戶',
  },
  status: {
    active: '進行中',
    inactive: '未啟用',
    scheduled: '已排程',
    expired: '已過期',
  },
  statusInfo: {
    title: '促銷狀態',
    redemptions: '兌換次數: %{current} / %{max}',
  },
  helpers: {
    code: '共用代碼類型必填',
    codeType: '獨立代碼需另外生成',
    minChargeAmount: '符合資格的最低充電金額',
    membershipLevels: '選擇會員等級（留空代表所有等級）',
    maxUsesTotal: '所有用戶的總兌換次數',
    maxUsesPerUser: '每位用戶最多可兌換次數',
    priority: '數字越小優先級越高（優先套用）',
    sites: '留空代表所有站點，或指定包含/排除的站點',
  },
  memberships: {
    standard: '標準會員',
    silver: '銀卡會員',
    gold: '金卡會員',
    platinum: '白金卡會員',
    vip: 'VIP會員',
  },
  days: {
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
  },
  priorityLevels: {
    1: '1 - 最高優先級',
    2: '2 - 非常高',
    3: '3 - 高',
    4: '4',
    5: '5 - 中等',
    6: '6',
    7: '7 - 低',
    8: '8',
    9: '9',
    10: '10 - 最低優先級',
  },
  multiLanguage: {
    title: '多語言翻譯',
    description: '提供促銷活動名稱和說明的不同語言翻譯。如未提供，將使用主要欄位作為備用。',
    copyFromBasic: '從基本資訊複製',
    note: '注意：英文是預設語言。其他語言為選填，如未提供將使用主要的名稱和說明欄位。',
  },
  terms: {
    title: '條款與細則',
    description: '新增此促銷活動的條款與細則。條款將按順序顯示在手機應用程式中。',
    noTerms: '尚未新增條款。點擊「新增條款」以新增第一個條款。',
    addTerm: '新增條款',
    copyFromEnglish: '從英文複製',
    noteOtherLangs: '注意：英文是預設語言。其他語言為選填，如未提供將使用英文版本。',
  },
  typeInfo: {
    coupon: '用戶需手動輸入/套用代碼',
    timeLimited: '在有效期間自動套用',
  },
  discountFields: {
    percentageLabel: '折扣百分比 (%)',
    percentageHelper: '輸入百分比（例如：50 代表 50% 折扣）',
    fixedAmountLabel: '折扣金額 (港幣)',
    fixedAmountHelper: '輸入港幣金額（例如：100 代表減 HKD 100）',
    freeCreditLabel: '免費點數金額 (港幣)',
    freeCreditHelper: '輸入要加入錢包的港幣點數金額',
  },
  timeHelpers: {
    leaveEmptyAllDay: '留空代表全天',
    leaveEmptyAllDays: '留空代表所有日子',
  },
  restrictionHelpers: {
    sitesHelper: '留空代表適用於所有站點',
    chargerTypesHelper: '留空代表適用於所有充電器類型',
    selectChargerType: '選擇充電器類型',
  },
  create: {
    title: '建立促銷活動',
    subtitle: '設定新的促銷活動或優惠券活動',
    backToList: '返回促銷活動列表',
    createHint: '建立包含折扣碼、限時優惠或針對特定用戶群組的特殊定價促銷活動。設定有效期限、使用次數限制和目標規則。',
  },
  show: {
    uniqueCouponCodes: '獨立優惠券代碼',
    exportCsv: '匯出 CSV',
    generateCodes: '生成代碼',
    availableCodes: '可用代碼',
    redeemedCodes: '已兌換代碼',
    totalCodes: '總代碼數',
    searchPlaceholder: '按代碼、批次名稱或合作夥伴參考搜尋...',
    noCodes: '尚未生成優惠券代碼。點擊「生成代碼」為此促銷活動建立獨立代碼。',
    termsAndConditions: '條款與細則',
    timeline: '時間軸',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    code: '代碼',
    statusLabel: '狀態',
    redeemedAt: '兌換時間',
    redeemedBy: '兌換者',
    actions: '操作',
    rowsPerPage: '每頁行數',
    allMembershipLevels: '所有會員等級',
    allDaysOfWeek: '所有星期',
    allSites: '所有站點',
    allChargerTypes: '所有充電器類型',
    available: '可用',
    redeemed: '已兌換',
    noMinimum: '無最低消費',
    generateDialog: {
      title: '生成獨立優惠券代碼',
      batchName: '批次名稱',
      batchNameHelper: '此批次代碼的名稱（例如：2025夏季促銷、VIP批次）',
      numberOfCodes: '代碼數量',
      numberOfCodesHelper: '要生成的獨立代碼數量（最多 10,000）',
      codeFormatOptions: '代碼格式選項',
      codeLength: '代碼長度',
      codeLengthHelper: '總字元數（6-20）',
      segmentLength: '分段長度',
      segmentLengthHelper: '每段字元數（3-6）',
      separator: '分隔符號',
      separatorHelper: '分段之間的字元',
      preview: '預覽：',
      previewText: '根據目前設定，代碼格式將如下：',
      expiresOn: '代碼將於以下日期過期：',
      sameAsPromotion: '（與促銷活動到期日相同）',
      thirtyDays: '從現在起 30 天',
      cancel: '取消',
      generateButton: '生成 %{quantity} 個代碼',
    },
  },
  edit: {
    title: '編輯促銷活動',
    typeCodeLocked: '建立後無法更改促銷類型和代碼類型。',
    uniqueCodesManaged: '獨立優惠券代碼需另外管理。您可以從促銷活動詳情頁面生成和管理代碼。',
    usageInfo: '此促銷活動已使用 %{count} 次。',
    dangerZone: '危險區域',
    cannotDeleteWithRedemptions: '無法刪除已有兌換記錄的促銷活動。請改為停用。',
    deleteWarning: '永久刪除此促銷活動。此操作無法復原。',
    deleteButton: '刪除',
    deleteButtonTitle: '無法刪除已有兌換記錄的促銷活動',
    confirmDeletion: '確認刪除',
    deletionWarningStrong: '此操作無法復原！',
    deletionWarningText: '您即將永久刪除 %{name}。所有促銷活動資料將遺失。',
    typeToConfirm: '在下方輸入 %{name} 以確認：',
    nameDoesNotMatch: '名稱不符',
    cancel: '取消',
    deletePromotion: '刪除促銷活動',
    selectSites: '選擇站點（留空代表所有站點）',
    selectChargerTypes: '選擇充電器類型（留空代表所有類型）',
  },
  notifications: {
    created: '促銷活動建立成功',
    updated: '促銷活動更新成功',
    deleted: '促銷活動刪除成功',
    error: {
      create: '建立促銷活動失敗',
      update: '更新促銷活動失敗',
      delete: '刪除促銷活動失敗',
    },
  },
};